let pageIsReloading = false;

export const ServiceWorkerWatchers = {
  newServiceWorkerActive(serviceWorker: ServiceWorkerContainer) {
    if (!serviceWorker) {
      return;
    }
    serviceWorker.addEventListener("controllerchange", () => {
      if (pageIsReloading) {
        return;
      }
      window.location.reload();
      pageIsReloading = true;
    });
  },

  newServiceWorkerWaiting(registration: ServiceWorkerRegistration) {
    if (!registration.waiting) {
      return;
    }
    alert("New version available. Reloading page...");
    registration.waiting.postMessage({ action: "skipWaiting" });
  },
};
